// Dev-only debug surface for the git-store layer. Imported once from
// main.tsx so anyone debugging in the browser console can poke at the
// repo without first finding the right module to import.
//
// Use from DevTools:
//   await window.__gitStoreDebug.log('data/channels/<id>.json')
//   await window.__gitStoreDebug.readAt('<oid>', 'data/channels/<id>.json')
//   await window.__gitStoreDebug.allChannels()
//   await window.__gitStoreDebug.allLibrary()
//
// The surface is intentionally minimal — anything heavier deserves
// proper UI rather than a console alias.

import { initGitStore, logForPath, readFileAt, _internal } from "./index";

declare global {
  interface Window {
    __gitStoreDebug?: {
      init: typeof initGitStore;
      log: typeof logForPath;
      readAt: typeof readFileAt;
      allChannels: () => Promise<string[]>;
      allLibrary: () => Promise<string[]>;
      fsName: string;
      repoDir: string;
    };
  }
}

async function listDataDir(subpath: string): Promise<string[]> {
  await initGitStore();
  const fs = _internal.getFs();
  try {
    return await fs.promises.readdir(`${_internal.REPO_DIR}/data/${subpath}`);
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    if (/ENOENT/i.test(msg)) return [];
    throw e;
  }
}

if (typeof window !== "undefined") {
  window.__gitStoreDebug = {
    init: initGitStore,
    log: logForPath,
    readAt: readFileAt,
    allChannels: () => listDataDir("channels"),
    allLibrary: () => listDataDir("library"),
    fsName: _internal.FS_NAME,
    repoDir: _internal.REPO_DIR,
  };
}
